<template>
    <div :class="{'hidden-text-field': isHidden}">
        <v-text-field :solo="dark" :error="error" @change="onChange" v-model="input" :label="label"></v-text-field>
    </div>
</template>
<script>
    export default {
        props: {
            dark: Boolean,
            label: {
                type: String,
                default: 'Введите результат'
            },
            error: Boolean,
            value: String,
            id: [String, Number],
            isHidden: Number
        },
        data () {
            return {
                input: ''
            }
        },
        methods: {
            onChange () {
                let value = this.input
                this.$emit('input', value)
            }
        },
        watch: {
            id () {
                this.input = ''
            }
        }
    }
</script>
<style lang="stylus" scoped>
    .hidden-text-field {
        opacity 0
        height 0
        overflow hidden
        pointer-events none
    }
</style>